import { getBit } from "../../../helpers/binary-helpers.js";
export function getBitSubOperations(cpu) {
    const { registers, memory } = cpu;
    function getBitAndSetFlags(value, position) {
        const bit = getBit(value, position);
        registers.F.isResultZero = !bit;
        registers.F.isHalfCarry = true;
        registers.F.isSubtraction = false;
    }
    // ****************
    // * Bit b, A
    // ****************
    function getBitBAByteDefinition(bitPosition, registerCode) {
        return (0b01 << 6) + (bitPosition << 3) + registerCode;
    }
    cpu.registers.baseRegisters.forEach(register => {
        for (let bitPosition = 0; bitPosition < 8; bitPosition++) {
            cpu.addCbOperation({
                byteDefinition: getBitBAByteDefinition(bitPosition, register.code),
                instruction: `BIT ${bitPosition}, ${register.name}`,
                cycleTime: 8,
                byteLength: 2,
                execute() {
                    getBitAndSetFlags(register.value, bitPosition);
                }
            });
        }
    });
    // ****************
    // * Bit b, (HL)
    // ****************
    function getBitHLByteDefinition(bitPosition) {
        return (0b01 << 6) + (bitPosition << 3) + 0b110;
    }
    for (let bitPosition = 0; bitPosition < 8; bitPosition++) {
        cpu.addCbOperation({
            byteDefinition: getBitHLByteDefinition(bitPosition),
            instruction: `BIT ${bitPosition}, (HL)`,
            cycleTime: 12,
            byteLength: 2,
            execute() {
                const value = memory.readByte(registers.HL.value);
                getBitAndSetFlags(value, bitPosition);
            }
        });
    }
}
//# sourceMappingURL=bit-operations.js.map